import React from 'react';

/**
 * @deprecated This component is deprecated. Use the shadcn Card component instead:
 *
 * ```tsx
 * import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
 *
 * <Card>
 *   <CardHeader>
 *     <CardTitle>{title}</CardTitle>
 *     {headerRight}
 *   </CardHeader>
 *   <CardContent>
 *     {children}
 *   </CardContent>
 * </Card>
 * ```
 *
 * See DESIGN_SYSTEM.md for full migration guide.
 */
interface CardProps {
  title?: string;
  className?: string;
  children: React.ReactNode;
  headerRight?: React.ReactNode;
}

/**
 * @deprecated Use `@/components/ui/card` instead. See DESIGN_SYSTEM.md
 */
const Card: React.FC<CardProps> = ({ title, className = '', children, headerRight }) => {
  if (process.env.NODE_ENV === 'development') {
    console.warn(
      '[DEPRECATED] v3/shared/Card is deprecated. Use @/components/ui/card instead. See DESIGN_SYSTEM.md'
    );
  }
  return (
    <div className={`bg-white rounded-xl ${className}`}>
      {(title || headerRight) && (
        <div className="px-4 pt-4 pb-2 flex items-center justify-between">
          {title && (
            <div className="text-figma-base font-semibold text-figma-text-primary">{title}</div>
          )}
          {headerRight}
        </div>
      )}
      <div className={`${title || headerRight ? 'px-4 pb-4' : 'p-4'}`}>
        {children}
      </div>
    </div>
  );
};

export default Card;
